export default __webpack_public_path__ + "static/media/caftan-ahlam-screenshots.18061f1c.jpg";